// old imports

// needed to make kits UI work
require("../legacy/js/_kits").default;

// new imports
import React from "react";
import classnames from "classnames";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import defer from "lodash/defer";
import { REDUCER_KEY } from "redux-windowsize";
import ColorSelection from "./color-selection";
import { SuperUserActions } from "./fort-super-user-actions";
import IconView from "./nounproject-icon-view";
import IconDownloadFlow from "./nounproject-icon-download-flow";
import Metrics from "../legacy/helpers/metrics";
import IconRelatedIcons from "./download-flow/icon-related-icons";
import IconShare from "./download-flow/icon-share";
import EditorControls from "./editor/editor-controls";
import { phases, licenses } from "../reducers/download";

class NounProjectIconHero extends React.Component {
    constructor(props) {
        super(props);

        this.containerEl = null;
        this.setContainerEl = this.setContainerEl.bind(this);
        this.state = {};
    }

    setContainerEl(el) {
        this.containerEl = el;

        if (this.props.scrollToElement && this.state.wantsScroll) {
            this.props.uiScrollToElement(this.containerEl);

            this.setState({
                wantsScroll: false
            });
        }
    }
    componentDidMount() {
        if (this.props.scrollToElement) {
            if (this.containerEl) {
                this.props.uiScrollToElement(this.containerEl);
            } else {
                this.setState({
                    wantsScroll: true
                });
            }
        }

        if (this.props.icon !== undefined) {
            return new Metrics().icon_hero(this.props.icon.id);
        }

        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.scrollToElement) {
            if (prevProps.icon && this.props.icon) {
                if (this.props.icon.id != prevProps.icon.id) {
                    this.props.uiScrollToElement(this.containerEl);
                }
            }

            if (
                this.props.showInModal &&
                prevProps.status != this.props.status
            ) {
                if (this.props.status == phases.INITIAL) {
                    defer(() => this.props.uiScrollToElement(this.containerEl));
                }
            }
        }
    }

    handleCloseClick = e => {
        if (!this.props.processing) {
            this.props.onCloseAction();
        }
    };

    render() {
        let { status, license, usingPremiumFeatures } = this.props;

        let superUserActions;

        if (this.props.icon) {
            if (
                this.props.icon &&
                this.props.currentUser !== undefined &&
                this.props.currentUser.is_superuser
            ) {
                superUserActions = (
                    <SuperUserActions
                        superUser={this.props.currentUser.is_superuser}
                        iconId={this.props.icon.id}
                        uploaderId={this.props.icon.uploader_id}
                    />
                );
            }

            let closeButton,
                heroPreview,
                heroEditing,
                heroMeta,
                iconCollections,
                withAttribution;

            if (this.props.onCloseAction) {
                closeButton = (
                    <div
                        className="esc-page ui_close"
                        title="Close this menu"
                        onClick={this.handleCloseClick}
                    />
                );
            }

            withAttribution =
                license == licenses.CREATIVE_COMMONS && status != phases.UPSELL;

            let showingInModal =
                this.props.showInModal && status != phases.INITIAL;

            if (this.props.icon) {
                heroPreview = (
                    <IconView
                        icon={this.props.icon}
                        withAttribution={withAttribution}
                    />
                );
            }

            heroMeta = (
                <IconDownloadFlow
                    showInModal={this.props.showInModal}
                    collection={this.props.collection}
                    icon={this.props.icon}
                    refetchIcon={this.props.refetchIcon}
                    onCloseAction={this.props.onCloseAction}
                />
            );

            heroEditing = <EditorControls />;

            let viewMore;
            if (
                (status == phases.INITIAL || status == phases.DOWNLOAD_READY) &&
                this.props.showInModal
            ) {
                viewMore = (
                    <IconRelatedIcons
                        icon={this.props.icon}
                        iconId={this.props.iconId}
                        className="container"
                    />
                );
            }

            let containerClass = classnames("view-container");
            return (
                <section
                    className="nounproject-icon-hero"
                    ref={this.setContainerEl}
                >
                    <div className="hero-page-width-container margin-b-m">
                        {superUserActions}
                        <div className={containerClass}>
                            {heroPreview}
                            {heroEditing}
                        </div>
                        {heroMeta}
                        <div className="download-icon-actions">
                            {closeButton}
                            <IconShare
                                icon={this.props.icon}
                                showModal={this.props.showModal}
                            />
                        </div>
                    </div>
                    {viewMore}
                </section>
            );
        } else {
            return null;
        }
    }
}

const HeroAttributionToggle = props => {
    let enabled = props.previewAttribution ? "x" : "";
    let className = classnames("hero-attribution-toggle", {
        enabled
    });
    return (
        <div
            className={className}
            onClick={props.toggle.bind(null, props.icon.id)}
        >
            {enabled} Include Attribution
        </div>
    );
};

function mapStateToProps(state, props) {
    let { download, stripe } = state;
    let viewport = state[REDUCER_KEY];

    let { status, license, usingPremiumFeatures, isPremiumUser } = download;

    let apiResponse = state.apiResponse,
        icon,
        currentUser;

    if (
        download &&
        props.icon &&
        download.pendingDownload &&
        download.pendingDownload.id == props.icon.id
    ) {
        icon = download.pendingDownload;
    } else {
        icon = props.icon;
    }

    if (!icon) {
        let { icons } = state;
        let storedIcon = icons[props.iconId];
        if (storedIcon) {
            icon = storedIcon;
        }
    }

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    let processing = download.processing || stripe.processing;

    return {
        status,
        apiResponse,
        icon,
        currentUser,
        license,
        viewport,
        usingPremiumFeatures,
        isPremiumUser,
        processing
    };
}

module.exports = connect(mapStateToProps, {
    uiScrollToElement: actions.uiScrollToElement,
    showModal: actions.showModal
})(NounProjectIconHero);
